export default __webpack_public_path__ + "static/media/80s_line_cleared.251484c8.mp3";